import React from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';
import { useTheme } from '../providers/ThemeProvider';
export function Toaster() {
  const {
    theme
  } = useTheme();
  const resolvedTheme = theme === 'system' ? window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light' : theme;
  return <SonnerToaster theme={resolvedTheme} position="top-center" toastOptions={{
    style: {
      background: 'hsl(var(--card))',
      border: '1px solid hsl(var(--border))',
      color: 'hsl(var(--foreground))'
    },
    className: 'rounded-xl'
  }} data-id="element-3237" data-mp="1mxtt9ctxe6q9" />;
}
export { toast };